{
	"title": "Transaction not found",
	"description": "Please go to the overview and enter a valid transaction ID. A transaction ID can be found on a declaration or on an invoice.",
	"secondaryButtonTitle": "Show start page"
}
